import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { CardWrapper, BoxButton } from './styles';

// Modal de Ajuda
const HelpModal = ({ onClose }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Informação sobre dados
        <br />
        requisitados
      </Title>
      <Text>
        Para entrar com o processo de revisão do FGTS é preciso se identificar perante a Justiça, comprovando que você é a pessoa titular do FGTS, por este motivo solicitamos o preenchimento dos seus dados que serão usados no documento que dá início ao processo. Este documento se chama petição inicial.
      </Text>
      <BoxButton>
        <Button onClick={() => {
          window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
          window.Intercom('show');
          onClose(false);
        }}
        >
          Iniciar conversa com o suporte
        </Button>
      </BoxButton>
    </CardWrapper>
  );
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
